import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const deleteVisitorType = (id: number): AxiosPromise =>
  instance.delete(`/api/visitorTypes/${id}`);

export default deleteVisitorType;
